export default "__VITE_ASSET__D4tOkV4w__"